import { SCHEDULE } from "library/constants.mjs"
import { PlanRoot } from "library/tree/constants.mjs"

export const ALL_SCOPE = "all"

export const SEARCH_SCOPES = [
    { id: ALL_SCOPE, label: "All", async: true },
    { id: "regime", label: "Regimes" },
    { id: "facility", label: "Facilities" },
    { id: "floor", label: "Floors" },
    { id: "space", label: "Spaces" },
    { id: "schedule", label: "Schedules" },
    { id: "asset", label: "Assets", async: true },
]

export function scopeOf(searchResult) {
    if (searchResult.isAsset) return "asset"
    if (searchResult[PlanRoot]) return "regime"
    if (searchResult.data?.type === "facility") return "facility"
    if (searchResult.data?.subType === "floor") return "floor"
    if (searchResult.data?.subType === "space") return "space"
    if (searchResult.type === SCHEDULE) return "schedule"
    return "other"
}

export function scopeLabelFor(scopeId) {
    return SEARCH_SCOPES.find((scope) => scope.id === scopeId)?.label ?? "results"
}

export function isAsyncScope(scopeId) {
    return !!SEARCH_SCOPES.find((scope) => scope.id === scopeId)?.async
}

export function isSelectableScope(scopeId, scopeCounts, loading) {
    if (scopeId === ALL_SCOPE) return true
    if (loading && isAsyncScope(scopeId)) return true
    return (scopeCounts[scopeId] ?? 0) > 0
}
